import { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './CitationChip.module.scss';

export type CitationChipProps = {
  children: ReactNode;
  className?: string;
};

/** Numbered chip used for inline AI assistant citations. */
export function CitationChip({ children, className }: CitationChipProps) {
  return (
    <span className={clsx(styles['citation-chip'], className)}>{children}</span>
  );
}
